export default __webpack_public_path__ + "static/Paved-69915f69e7a1e2a9f158b950fb6ce88c.webp";